import * as React from 'react';
import {Platform, StyleSheet, Pressable, View} from 'react-native';

import Localized from 'src/constants/AppStrings';
import Styles from '../../Styles';
import type {ScreenProps} from 'src/types/Screen';
import AVText from '../AVText';
import Settings from 'src/Settings';
import Util from 'src/Util';
import AccountStore from 'src/stores/AccountStore';
import type {Referral} from 'src/types/Referral';
import UnReadlIcon from 'src/components/img/svg/UnReadIcon';
import {getDescriber} from '../descriptor/DescriptorType';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import {getNotificationDescriber} from 'src/components/elements/notificationDescriptor/DescriptorType';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';

type ReferralItemProps = ScreenProps &
  WithGlobalizeProps & {
    referral: Referral;
    onPress?: () => void;
  };

class ReferralItem extends React.Component<ReferralItemProps> {
  constructor(props: ReferralItemProps) {
    super(props);
  }

  renderItemDescription(isSender) {
    const {referral} = this.props;
    const {Labels} = Localized;
    const amount = referral?.amount ?? 0;
    const currency = Util.formatCurrency(
      this.props,
      amount,
      AccountStore.getCurrency(),
    );

    if (isSender) {
      const receiverName = referral?.receiverName ?? '';
      return Labels.formatString(
        Labels.rewards_description_text_sender,
        receiverName,
        currency,
      );
    } else {
      return Labels.formatString(
        Labels.rewards_description_text_receiver,
        currency,
      );
    }
  }

  renderItemDescriptionHeaderTitle() {
    const {referral} = this.props;
    const {Labels} = Localized;
    const formattedAmount = this.getFormattedAmountItem(referral?.amount);
    const textItemPrefix = Labels.formatString(
      Labels.referral_invite_friends,
      formattedAmount,
      formattedAmount,
    );
    return `${textItemPrefix}`;
  }

  getFormattedAmountItem(amount) {
    const formatted = Util.formatCurrency(
      this.props,
      amount ?? 0,
      AccountStore.getCurrency(),
    );
    return formatted?.split('.')[0];
  }

  renderItemDescriptiontitle() {
    return this.renderItemDescriptionHeaderTitle();
  }

  renderSubtitle(isSender: boolean) {
    return isSender
      ? Localized.Labels.you_referral_amount
      : Localized.Labels.account_created;
  }
  render() {
    const {referral, onPress} = this.props;
    const isSender = referral.sender === AccountStore.getAccountId();
    const describerprops = {
      referral,
      isSender,
    };
    return (
      <Pressable
        onPress={onPress}
        style={[
          getDescriber().getSnackItemStyleDescriptor().container,
          !Settings.isCanteen() && Styles.Style.shadow,
          !Settings.isRefiveAnd365Pay() && {
            borderBottomWidth: StyleSheet.hairlineWidth,
            alignSelf: 'center',
          },
          !Settings.isRefiveAnd365Pay() && {
            borderBottomWidth: 1,
            borderBottomColor: '#9A9A9F',
          },
        ]}
        accessible
        accessibilityHint="Double tap to navigate to the Reward Received detaile screen"
        accessibilityLabel={[
          Localized.Labels.rewards_detail_header_name,
          this.renderItemDescriptiontitle(),
          this.renderItemDescription(isSender),
        ].join('. ')}
        nativeID="Inbox referral Item"
      >
        {getDescriber().referralImageTemplateDescriptor(describerprops)}
        <View style={getDescriber().getSnackItemStyleDescriptor().messageLeft}>
          {Settings.isRefiveAnd365Pay() ? (
            <View style={[styles.titleHeaderView]}>
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                style={[
                  getDescriber().getSnackItemStyleDescriptor().referalTitle,
                  styles.statusText,
                ]}
              >
                {Localized.Labels.rewards_detail_header_name}
              </AVText>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  style={[
                    getDescriber().getSnackItemStyleDescriptor().referralDate,
                    styles.commonRow,
                  ]}
                >
                  {getDescriber().referralItemDateDescriptor(describerprops)}
                </AVText>
              </View>
            </View>
          ) : (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                numberOfLines={1}
                ellipsizeMode="tail"
                style={[
                  getDescriber().getSnackItemStyleDescriptor().referalTitle,
                ]}
                accessible
                testID="qa_NotificationType_txt"
                nativeID="qa_NotificationType_txt"
              >
                {Localized.Labels.rewards_detail_header_name}
              </AVText>

              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                numberOfLines={1}
                ellipsizeMode="tail"
                style={[
                  getDescriber().getSnackItemStyleDescriptor().referralDate,
                ]}
                accessible
                testID="qa_MessageDate_txt"
                nativeID="qa_MessageDate_txt"
              >
                {getDescriber().referralItemDateDescriptor(describerprops)}
              </AVText>
            </View>
          )}

          {Settings.isRefiveAnd365Pay() ? (
            <AVText
              style={getDescriber().getSnackItemStyleDescriptor().subject}
              numberOfLines={getDescriber().snackItemNumberDescriptor()}
              accessible
              testID="qa_MessageSubject_txt"
              nativeID="qa_MessageSubject_txt"
            >
              {this.renderItemDescriptiontitle()}
            </AVText>
          ) : (
            <View style={styles.cpUnreadIcon}>
              {!Settings.isRefiveAnd365Pay() && !referral.isRead && (
                <UnReadlIcon
                  color={getNotificationDescriber().getUnreadMessageIconColor()}
                />
              )}
              <AVText
                style={getDescriber().getSnackItemStyleDescriptor().subject}
                numberOfLines={getDescriber().snackItemNumberDescriptor()}
                accessible
                testID="qa_MessageSubject_txt"
                nativeID="qa_MessageSubject_txt"
              >
                {this.renderItemDescriptiontitle()}
              </AVText>
            </View>
          )}
          <AVText
            style={[
              getDescriber().getSnackItemStyleDescriptor().message,
              Platform.OS === 'web'
                ? styles.referralItemViewWeb
                : styles.referralItemView,
            ]}
            numberOfLines={getDescriber().snackItemNumberDescriptor()}
            accessible
            testID="qa_MessageBody_txt"
            nativeID="qa_MessageBody_txt"
          >
            {this.renderItemDescription(isSender)}
          </AVText>
        </View>

        {Settings.isRefiveAnd365Pay() && (
          <View
            style={getDescriber().getSnackItemStyleDescriptor().chevronRight}
            accessible
            accessibilityLabel="Snack Item Icon"
          >
            <ChevronRight />
          </View>
        )}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m3,
    paddingLeft: Styles.Spacing.m3,
    paddingRight: Styles.Spacing.m3 + Styles.Spacing.m2,
    flex: 1,
    flexDirection: 'row',
    borderBottomColor: Styles.lightGray,
    borderBottomWidth: StyleSheet.hairlineWidth,
    minHeight: Styles.Heights.touchTargetHeight2,
  },
  starContainer: {
    justifyContent: 'center',
  },
  mainContent: {
    flex: 1,
    marginStart: Styles.Spacing.m2,
    marginEnd: Styles.Spacing.m3,
  },
  topSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bottomSection: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: Styles.Spacing.m1,
  },
  status: {
    fontWeight: '600',
    flex: 1,
    fontSize: Styles.Fonts.f0,
    textTransform: 'capitalize',
    justifyContent: 'center',
  },
  title: {
    fontSize: Settings.isNewUI ? Styles.Fonts.f7 : Styles.Fonts.f1,
    fontWeight: '600',
    color: Styles.darkColor,
  },
  description: {
    flex: 1,
    fontSize: Settings.isNewUI ? Styles.Fonts.f7 : Styles.Fonts.f0,
    marginEnd: Styles.Spacing.m5,
    marginBottom: Styles.Spacing.m1,
  },
  date: {
    color: Styles.lightGray,
    fontSize: Settings.isNewUI ? Styles.Fonts.f1 : Styles.Fonts.f0,
  },
  titleHeaderView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  commonRow: {
    flexDirection: 'row',
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  arrow: {
    width: 24,
    height: 24,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  statusText: {
    textAlign: 'auto',
    paddingRight: 16,
  },
  referralItemViewWeb: {
    flex: 1,
    width: '90%',
  },
  referralItemView: {},
  cpUnreadIcon: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
});
export default withGlobalize(ReferralItem);
